"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var e=require("react/jsx-runtime"),a=require("@vds/typography"),i=require("@vds/buttons"),s=require("@plans/type-lockups"),t=require("@vds-tokens/core"),l=require("styled-components"),n=require("@plans/utilities"),o=require("@plans/lists"),r=require("../helperText/index.js");function d(e){return e&&e.__esModule?e:{default:e}}var p=d(l);const u=p.default.div.withConfig({displayName:"Wrapper",componentId:"VDS__sc-15tjy4u-0"})`
  display: flex;
  flex-direction: column;
  gap: ${({size:e})=>"large"===e?t.LayoutTokens.space["6X"].value:t.LayoutTokens.space["4X"].value};

  @media (min-width: ${n.breakpoints.tabletSmall.min}) {
    gap: ${({size:e})=>"medium"===e?t.LayoutTokens.space["4X"].value:t.LayoutTokens.space["6X"].value};
  }
`,c=p.default.div.withConfig({displayName:"TitleWrapperDesktop",componentId:"VDS__sc-15tjy4u-1"})`
  padding-bottom: ${t.LayoutTokens.space["1X"].value};
  @media (max-width: ${n.breakpoints.mobileLarge.max}) {
    display: none;
  }
`,m=p.default.div.withConfig({displayName:"TitleWrapperMobile",componentId:"VDS__sc-15tjy4u-2"})`
  padding-bottom: ${t.LayoutTokens.space["1X"].value};
  @media (min-width: ${n.breakpoints.mobileLarge.max}) {
    display: none;
  }
`,g=p.default.div.withConfig({displayName:"HeaderRightWrapper",componentId:"VDS__sc-15tjy4u-3"})`
  padding-left: ${t.LayoutTokens.space["3X"].value};
  text-align: right;
`,y=p.default.div.withConfig({displayName:"ButtonGroupMobileWrapper",componentId:"VDS__sc-15tjy4u-4"})`
  align-self: flex-start;
  display: flex;

  @media (min-width: ${n.breakpoints.tabletSmall.min}) {
    display: none;
  }
`,j=p.default.div.withConfig({displayName:"ButtonGroupDesktopWrapper",componentId:"VDS__sc-15tjy4u-5"})`
  display: none;

  @media (min-width: ${n.breakpoints.tabletSmall.min}) {
    display: flex;
    align-self: flex-start;
  }
`,x=p.default.div.withConfig({displayName:"HeaderWrapper",componentId:"VDS__sc-15tjy4u-6"})`
  align-items: flex-start;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding-bottom: ${({helperText:e})=>e&&t.LayoutTokens.space["1X"].value};
`,b=p.default.div.withConfig({displayName:"PriceLockupMobileWrapper",componentId:"VDS__sc-15tjy4u-7"})`
  display: flex;

  @media (min-width: ${n.breakpoints.tabletSmall.min}) {
    display: none;
  }
`,f=p.default.div.withConfig({displayName:"PriceLockupDesktopWrapper",componentId:"VDS__sc-15tjy4u-8"})`
  display: none;

  @media (min-width: ${n.breakpoints.tabletSmall.min}) {
    display: flex;
  }
`,h=p.default.div.withConfig({displayName:"HelperTextWrapper",componentId:"VDS__sc-15tjy4u-9"})`
  display: flex;
  width: 80%;
`,v=p.default.div.withConfig({displayName:"ListWrapper",componentId:"VDS__sc-15tjy4u-10"})`
  display: flex;
  flex-direction: column;
  > ul {
    padding: 0 0 0 0;
  }
  gap: ${({size:e})=>"large"===e?t.LayoutTokens.space["6X"].value:t.LayoutTokens.space["4X"].value};

  @media (min-width: ${n.breakpoints.tabletSmall.min}) {
    > ul {
      padding: 0 0 0 0;
    }
    gap: ${({size:e})=>"medium"===e?t.LayoutTokens.space["4X"].value:t.LayoutTokens.space["6X"].value};
  }
`;exports.default=({helperText:l,title:n,list:d,price:p,lists:k,buttonGroup:w,type:_={variant:"textLink"},size:T,surface:L="light"})=>{const $=()=>"large"===T?"medium":"small",z=()=>e.jsxs(e.Fragment,{children:[e.jsx(b,{children:p&&e.jsx(s.Pricing,Object.assign({size:"small",surface:L},p))}),e.jsx(f,{children:p&&e.jsx(s.Pricing,Object.assign({size:"small"===T?"medium":"small",surface:L},p))})]}),O=!!n||!!p||!!l;return e.jsxs(u,Object.assign({size:T},{children:[O&&e.jsxs("div",{children:[e.jsxs(x,Object.assign({helperText:l},{children:[e.jsxs("div",{children:[n&&e.jsxs(e.Fragment,{children:[e.jsx(c,{children:e.jsx(a.Body,Object.assign({size:"large"===T?"small":"large",color:"large"===T?t.ColorTokens.elements.primary[`on${L}`].value:t.ColorTokens.elements.secondary[`on${L}`].value,bold:"large"===T},n))}),e.jsx(m,{children:e.jsx(a.Body,Object.assign({size:"small"===T||"large"===T?"small":"large",bold:"large"===T,color:"large"===T?t.ColorTokens.elements.primary[`on${L}`].value:t.ColorTokens.elements.secondary[`on${L}`].value},n))})]}),p&&"right"!==p.alignment&&z()]}),e.jsxs(g,{children:["textLink"===_.variant&&_.textLink&&"right"!==(null==p?void 0:p.alignment)&&e.jsx(i.TextLink,Object.assign({type:"standAlone",size:"small",surface:L},_.textLink)),"button"===_.variant&&_.button&&"right"!==(null==p?void 0:p.alignment)&&e.jsx(i.Button,Object.assign({surface:L,size:"small",use:"secondary"},_.button)),"label"===_.variant&&_.label&&"right"!==(null==p?void 0:p.alignment)&&e.jsx("div",Object.assign({style:{maxWidth:140}},{children:e.jsx(a.Body,Object.assign({color:t.ColorTokens.elements.primary[`on${L}`].value,size:"small"},_.label))})),p&&"right"===p.alignment&&z()]})]})),l&&e.jsx(h,{children:e.jsx(r.default,Object.assign({surface:L,size:"medium"===T?"micro":"small",color:"small"===T?"secondary":"primary"},l))})]}),!k&&d&&(d?e.jsx(v,Object.assign({size:T},{children:e.jsx(o.ReviewList,Object.assign({spacing:"large"===T?"2X":"4X",size:$()},d,{surface:L}))})):null),!d&&k&&(k?e.jsx(v,Object.assign({size:T},{children:k.map((a=>e.jsx(o.ReviewList,Object.assign({size:$(),spacing:"large"===T?"2X":"4X"},a,{surface:L}))))})):null),w&&e.jsxs(e.Fragment,{children:[e.jsx(y,{children:e.jsx(i.ButtonGroup,{rowQuantity:{mobile:1,tablet:1,desktop:1},surface:L,alignment:"left",data:w.data.map((e=>Object.assign(Object.assign({},e),{size:"small"})))})}),e.jsx(j,{children:e.jsx(i.ButtonGroup,{rowQuantity:{mobile:1,tablet:1,desktop:1},surface:L,alignment:"left",data:w.data.map((e=>Object.assign(Object.assign({},e),{size:"small"===T?"large":"small"})))})})]})]}))};
